import { authorizedAction } from 'api'
import { ErrorProp } from './'

type DCAccessResponseProps =
  | {
      success: true
    }
  | {
      success: false
      error: ErrorProp
      message?: string
    }

export type DCAccessProps = {
  userId?: string
  unlock?: boolean
}

export async function dcAccess({
  userId,
  unlock = false,
}: DCAccessProps): Promise<DCAccessResponseProps> {
  try {
    if (!userId) {
      return {
        success: false,
        error: 'User ID is required',
      }
    }

    const response = await authorizedAction({
      action: unlock ? 'Student.Unlock' : 'Student.Lock',
      body: {
        Username: userId,
      },
    })

    const json = (await response.json()) as DCAccessResponseProps

    if (json.success) {
      return { success: true }
    } else {
      return {
        success: false,
        error: json.error ?? json.message,
      }
    }
  } catch (e: any) {
    throw e
  }
}
